<div class="detail-panel-description detail-panel--relations detail-panel--autocomplete-target"
     *ngIf="workPackage">
  <div class="detail-panel-description-content">
    <wp-relations [workPackage]="workPackage"></wp-relations>
  </div>
</div>
